import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { HabaCartSharedModule } from '@app/cart';
import { CustomCheckoutModule } from 'src/app/checkout/custom-checkout.module';
import { CheckoutHeaderComponent } from 'src/app/header/checkout-header/checkout-header.component';
import { HeaderComponent } from 'src/app/header/header.component';
import { NavigationModule } from 'src/app/navigation/navigation.module';

import { FormFieldsModule } from '@app/base-components';
import { CloudinaryModule } from '@cloudinary/ng';
import { NgbAccordionModule } from '@ng-bootstrap/ng-bootstrap';
import { I18nModule, UrlModule } from 'haba-core';
import { CountryPopupComponent } from 'src/app/header/country-popup/country-popup.component';
import { ContentfulModule } from '../contentful/contentful.module';
import { HorizontalMenuComponent } from './horizontal-menu/horizontal-menu.component';
import { SideMenuComponent } from './side-menu/side-menu.component';

import { RemoveDollarSignPipe } from './horizontal-menu/removeDollarSign.pipe';
import { ShopNavMobileComponent } from './shop-nav-mobile/shop-nav-mobile.component';

@NgModule({
  imports: [
    CommonModule,
    NavigationModule,
    UrlModule,
    I18nModule,
    HabaCartSharedModule,
    CustomCheckoutModule,
    RouterModule,
    CloudinaryModule,
    NgbAccordionModule,
    FormFieldsModule,
    ContentfulModule,
    HeaderComponent,
    CheckoutHeaderComponent,
    HorizontalMenuComponent,
    ShopNavMobileComponent,
    SideMenuComponent,
    CountryPopupComponent,
    RemoveDollarSignPipe,
  ],
  exports: [
    HeaderComponent,
    CheckoutHeaderComponent,
    HorizontalMenuComponent,
    ShopNavMobileComponent,
  ],
})
export class HeaderModule {}
